import { Skeleton } from "../../components/Skeleton/Skeleton.js";
import { jsx } from "react/jsx-runtime";
//#region src/blocks/DiagramShared/DiagramSkeleton.tsx
const DiagramSkeleton = () => /* @__PURE__ */ jsx("div", {
	className: "tw:my-3 tw:overflow-hidden tw:rounded-md tw:border tw:border-border tw:bg-muted tw:p-6",
	children: /* @__PURE__ */ jsx(Skeleton, { className: "tw:h-40" })
});
//#endregion
export { DiagramSkeleton };

//# sourceMappingURL=DiagramSkeleton.js.map